let compares = {};

const comparisonObserver = {
    get: (tileId) => compares[tileId],
    set: ({tileId, isCompare}) => (compares[tileId] = isCompare),
};
exports.comparisonObserver = comparisonObserver;
